import { attr, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  userId: attr('number'),
  serviceId: attr('number'),
  companyId: attr('number'),
  createdAt: attr('date'),
  updatedAt: attr('date'),
  marketReviewCount: attr('number'),
  adminScore: attr('number'),
  marketScore: attr('number'),
  weightedScore: attr('number'),
  projectCount: attr('number'),
  projectdigestCount: attr('number'),
  rank: attr('number'),

  service: belongsTo('service', { async: false }),
  user: belongsTo('user', { async: false }),
  company: belongsTo('company', { async: false }),
});
